module.exports = __webpack_public_path__ + "static/media/cal.e4cf0a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/cases/influencers/assets/cal.png
// module id = 297
// module chunks = 0